import axios from 'axios';
import React, { useEffect, useState } from 'react'


const SummaryPage = () => {

    const [cartItems, setCartItems] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [quantities, setQuantities] = useState([]);
  

    const fetchCartItems = async () => {
        try {
          const response = await axios.get('https://ecommerce-mern-server-side.onrender.com/api/cart/cart');
          const result = response.data
          setCartItems(result);
          console.log("checkout getting cart" , result)

          const initialQuantities = response.data.map(item => item.quantity);

          setQuantities(initialQuantities);
          calculateSubtotal(response.data, initialQuantities);
    

        } catch (error) {
          console.error('Error fetching cart items:', error);
        }
      };

      const calculateSubtotal = (items, quantities) => {
        const total = items.reduce((sum, item, index) => sum + item.productId.currentPrice * quantities[index], 0);
        setSubtotal(total);
      };


      useEffect(() => {
          fetchCartItems();
      },[] );



  return (
    <div>
        <section className="py-24 relative">
            <div className="w-full max-w-7xl px-4 md:px-5 lg-6 mx-auto">
                <h2 className="font-manrope font-bold text-4xl leading-10 text-black text-center">
                Payment Successful
                </h2>
                <p className="mt-4 font-normal text-lg leading-8 text-gray-500 mb-11 text-center">Thanks for making a purchase
                you can
                check our order summary frm below</p>
                <div className="main-box border border-gray-200 rounded-xl pt-6 max-w-xl max-lg:mx-auto lg:max-w-full">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between px-6 pb-6 border-b border-gray-200">
                    <div className="data">
                    <p className="font-semibold text-base leading-7 text-black">Order Id: <span className="text-indigo-600 font-medium">#10234987</span></p>
                    <p className="font-semibold text-base leading-7 text-black mt-4">Order Payment : <span className="text-gray-400 font-medium"> 18th march
                        2021</span></p>
                    </div>
                
                </div>
                <div className="w-full px-3 min-[400px]:px-6">

                    {
                        cartItems.map((item) => (
                            <div className="flex flex-col lg:flex-row items-center py-6 border-b border-gray-200 gap-6 w-full">
                            <div className="img-box max-lg:w-full">
                                <img src={`https://ecommerce-mern-server-side.onrender.com/uploads/${item.image}`} alt="Premium Watch image" className="aspect-square w-full lg:max-w-[140px] md:max-w-[180px] sm:max-w-[200px]" />
                            </div>
                            <div className="flex flex-row items-center w-full ">
                                <div className="grid grid-cols-1 lg:grid-cols-2 w-full">
                                <div className="flex items-center">
                                    <div className>
                                    <h2 className="font-semibold text-xl leading-8 text-black mb-3">
                                        {item.name}</h2>
                                    <p className="font-normal text-lg leading-8 text-gray-500 mb-3 ">
                                    Quantity: {item.quantity}</p>
                                    <div className="flex items-center ">
                                        <p className="font-medium text-base  text-black pr-4 mr-4 border-r border-gray-200">
                                        Size: <span className="text-gray-500">{item.productId.size}</span></p>
                                    </div>
                                    </div>
                                </div>
                                <div className="grid grid-cols-5">
                                    <div className="col-span-5 lg:col-span-1 flex items-center max-lg:mt-3">
                                    <div className="flex gap-3 lg:block">
                                        <p className="font-medium text-sm leading-7 text-black">price</p>
                                        <p className="lg:mt-4 font-medium text-sm leading-7 text-indigo-600">{item.productId.currentPrice}</p>
                                    </div>
                                    </div>
                                    <div className="col-span-5 lg:col-span-2 flex items-center max-lg:mt-3 ">
                                    <div className="flex gap-3 lg:block">
                                        <p className="font-medium text-sm leading-7 text-black">Status
                                        </p>
                                        <p className="font-medium text-sm leading-6 whitespace-nowrap py-0.5 px-3 rounded-full lg:mt-3 bg-emerald-50 text-emerald-600">
                                        Successfully Ordered</p>
                                    </div>
                                    </div>
                                    <div className="col-span-5 lg:col-span-2 flex items-center max-lg:mt-3">
                                    <div className="flex gap-3 lg:block">
                                        <p className="font-medium text-sm whitespace-nowrap leading-6 text-black">
                                        Expected Delivery Time</p>
                                        <p className="font-medium text-base whitespace-nowrap leading-7 lg:mt-3 text-emerald-500">
                                        20th July 2024</p>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        ))
                    }

                   



                   


                </div>
                <div className="w-full border-t border-gray-200 px-6 flex flex-col lg:flex-row items-center justify-between ">
                    <div className="flex flex-col sm:flex-row items-center max-lg:border-b border-gray-200">
                    
                    <p className="font-medium text-lg text-gray-900 pl-6 py-3 max-lg:text-center">Paid using Credit Card <span className="text-gray-500">ending with 8822</span></p>
                    </div>
                    <p className="font-semibold text-lg text-black py-6">Total Price: <span className="text-indigo-600"> PKR. {subtotal+200}</span></p>
                </div>
                </div>
            </div>
        </section>

                                            
    </div>
  )
}

export default SummaryPage
